import { WINDOW_MATERIAL_MODEL_LABELS, WINDOW_MATERIAL_MODEL_CHOICES, WINDOW_DAMAGE_TYPE_MODEL_LABELS, WINDOW_DAMAGE_TYPE_MODEL_CHOICES, WINDOW_GLAZING_TYPE_MODEL_LABELS, WINDOW_GLAZING_TYPE_MODEL_CHOICES, WINDOW_GLASS_TYPE_MODEL_LABELS, WINDOW_GLASS_TYPE_MODEL_CHOICES, WINDOW_TWO_LEAVES_WIDTH_MODEL_LABELS, WINDOW_ONE_LEAF_WIDTH_MODEL_LABELS, WINDOW_TWO_LEAVES_WIDTH_MODEL_CHOICES, WINDOW_ONE_LEAF_WIDTH_MODEL_CHOICES, WINDOW_ONE_LEAF_HEIGHT_MODEL_LABELS, WINDOW_TWO_LEAVES_HEIGHT_MODEL_LABELS, WINDOW_ONE_LEAF_HEIGHT_MODEL_CHOICES, WINDOW_TWO_LEAVES_HEIGHT_MODEL_CHOICES, GOOD_DAMAGE_TYPE_LABELS, WINDOW_MATERIAL_LABELS, } from '../goodDamage';
import { parseOptionalDimension } from '@declaration/helpers/typeFormatters';
import { numbersToChoices, translateChoices } from '@shared/choice';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { ModelFieldInputType } from '@shared/modelField/modelField';
import { WindowMaterial, WindowDamageType, } from '@shared/types/api/roomDamage';
import { optionalString, optionalTranslatableEnumTransform, optionalBooleanTransform, } from '@shared/utils/transform';
export function windowDetails(model, translate) {
    var _a;
    if (!model.type || !model.leafCount || !model.material)
        return null;
    const key = `${GOOD_DAMAGE_TYPE_LABELS[model.type]}.description`;
    return translate(key, (_a = model.leafCount) !== null && _a !== void 0 ? _a : 1, {
        material: translate(WINDOW_MATERIAL_LABELS[model.material]),
        count: model.leafCount,
    });
}
export function windowFields(model, context) {
    var _a, _b;
    const { translate, index } = context;
    const fields = [
        {
            label: translate('model.good_damage.window.leaf_count'),
            value: model.leafCount,
            displayedValue: optionalString(model.leafCount),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: numbersToChoices(1, 2, 3),
                },
                modelKey: `goodDamages.${index}.leafCount`,
                toPayload: (leafCount) => ({
                    leafCount,
                    leafWidth: null,
                    leafHeight: null,
                }),
            },
        },
        {
            label: translate('model.good_damage.window.material'),
            value: model.material,
            displayedValue: optionalTranslatableEnumTransform(model.material, WINDOW_MATERIAL_MODEL_LABELS, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(WINDOW_MATERIAL_MODEL_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.material`,
                toPayload: (material) => ({
                    material,
                    damageType: material === WindowMaterial.WOOD ? model.damageType : null,
                    isGlazingBroken: material === WindowMaterial.WOOD ? model.isGlazingBroken : null,
                    tileCount: material === WindowMaterial.WOOD ? model.tileCount : null,
                    biggestTileWidth: material === WindowMaterial.WOOD ? model.biggestTileWidth : null,
                    biggestTileHeight: material === WindowMaterial.WOOD ? model.biggestTileHeight : null,
                    leafWidth: material === WindowMaterial.PVC ||
                        material === WindowMaterial.METAL ||
                        model.damageType === WindowDamageType.DAMAGED
                        ? model.leafWidth
                        : null,
                    leafHeight: material === WindowMaterial.PVC ||
                        material === WindowMaterial.METAL ||
                        model.damageType === WindowDamageType.DAMAGED
                        ? model.leafHeight
                        : null,
                }),
            },
        },
    ];
    if (model.material === WindowMaterial.WOOD) {
        fields.push({
            label: translate('model.good_damage.window.damage_type'),
            value: model.damageType,
            displayedValue: optionalTranslatableEnumTransform(model.damageType, WINDOW_DAMAGE_TYPE_MODEL_LABELS, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(WINDOW_DAMAGE_TYPE_MODEL_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.damageType`,
                toPayload: (damageType) => {
                    const aesthetic = damageType === WindowDamageType.AESTHETIC;
                    return {
                        damageType,
                        isGlazingBroken: aesthetic ? model.isGlazingBroken : null,
                        tileCount: aesthetic ? model.tileCount : null,
                        biggestTileWidth: aesthetic ? model.biggestTileWidth : null,
                        biggestTileHeight: aesthetic ? model.biggestTileHeight : null,
                        leafWidth: aesthetic ? null : model.leafWidth,
                        leafHeight: aesthetic ? null : model.leafHeight,
                    };
                },
            },
        });
    }
    if (model.damageType === WindowDamageType.AESTHETIC) {
        fields.push({
            label: translate('model.good_damage.window.is_glazing_broken'),
            value: model.isGlazingBroken,
            displayedValue: optionalBooleanTransform(model.isGlazingBroken, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(YES_OR_NO_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.isGlazingBroken`,
                toPayload: (isGlazingBroken) => ({
                    isGlazingBroken,
                    tileCount: isGlazingBroken ? model.tileCount : null,
                    biggestTileWidth: isGlazingBroken ? model.biggestTileWidth : null,
                    biggestTileHeight: isGlazingBroken ? model.biggestTileHeight : null,
                    glazingType: isGlazingBroken ? model.glazingType : null,
                    glassType: isGlazingBroken ? model.glassType : null,
                }),
            },
        });
        if (model.isGlazingBroken) {
            fields.push({
                label: translate('model.good_damage.window.tile_count'),
                value: model.tileCount,
                displayedValue: optionalString(model.tileCount),
                editable: {
                    input: {
                        type: ModelFieldInputType.Number,
                    },
                    modelKey: `goodDamages.${index}.tileCount`,
                    toPayload: (tileCount) => ({ tileCount }),
                },
            }, {
                label: translate('model.good_damage.window.biggest_tile_width'),
                value: ((_a = model.biggestTileWidth) !== null && _a !== void 0 ? _a : 0) / 10,
                displayedValue: parseOptionalDimension(model.biggestTileWidth),
                editable: {
                    input: {
                        type: ModelFieldInputType.Number,
                    },
                    unit: 'cm',
                    modelKey: `goodDamages.${index}.biggestTileWidth`,
                    toPayload: (biggestTileWidth) => ({
                        biggestTileWidth: biggestTileWidth * 10,
                    }),
                },
            }, {
                label: translate('model.good_damage.window.biggest_tile_height'),
                value: ((_b = model.biggestTileHeight) !== null && _b !== void 0 ? _b : 0) / 10,
                displayedValue: parseOptionalDimension(model.biggestTileHeight),
                editable: {
                    input: {
                        type: ModelFieldInputType.Number,
                    },
                    unit: 'cm',
                    modelKey: `goodDamages.${index}.biggestTileHeight`,
                    toPayload: (biggestTileHeight) => ({
                        biggestTileHeight: biggestTileHeight * 10,
                    }),
                },
            });
        }
    }
    if (model.isGlazingBroken ||
        model.damageType === WindowDamageType.DAMAGED ||
        model.material === WindowMaterial.PVC ||
        model.material === WindowMaterial.METAL) {
        fields.push({
            label: translate('model.good_damage.window.glazing_type'),
            value: model.glazingType,
            displayedValue: optionalTranslatableEnumTransform(model.glazingType, WINDOW_GLAZING_TYPE_MODEL_LABELS, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(WINDOW_GLAZING_TYPE_MODEL_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.glazingType`,
                toPayload: (glazingType) => ({ glazingType }),
            },
        }, {
            label: translate('model.good_damage.window.glass_type'),
            value: model.glassType,
            displayedValue: optionalTranslatableEnumTransform(model.glassType, WINDOW_GLASS_TYPE_MODEL_LABELS, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(WINDOW_GLASS_TYPE_MODEL_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.glassType`,
                toPayload: (glassType) => ({ glassType }),
            },
        });
    }
    if ((model.material === WindowMaterial.PVC ||
        model.material === WindowMaterial.METAL ||
        model.damageType === WindowDamageType.DAMAGED) &&
        typeof model.leafCount === 'number') {
        fields.push({
            label: translate('model.good_damage.window.leaf_width'),
            value: model.leafWidth,
            displayedValue: optionalTranslatableEnumTransform(model.leafWidth, model.leafCount >= 2
                ? WINDOW_TWO_LEAVES_WIDTH_MODEL_LABELS
                : WINDOW_ONE_LEAF_WIDTH_MODEL_LABELS, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(model.leafCount >= 2
                        ? WINDOW_TWO_LEAVES_WIDTH_MODEL_CHOICES
                        : WINDOW_ONE_LEAF_WIDTH_MODEL_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.leafWidth`,
                toPayload: (leafWidth) => ({ leafWidth }),
            },
        }, {
            label: translate('model.good_damage.window.leaf_height'),
            value: model.leafHeight,
            displayedValue: optionalTranslatableEnumTransform(model.leafHeight, model.leafCount >= 2
                ? WINDOW_TWO_LEAVES_HEIGHT_MODEL_LABELS
                : WINDOW_ONE_LEAF_HEIGHT_MODEL_LABELS, translate),
            editable: {
                input: {
                    type: ModelFieldInputType.Radio,
                    choices: translateChoices(model.leafCount >= 2
                        ? WINDOW_TWO_LEAVES_HEIGHT_MODEL_CHOICES
                        : WINDOW_ONE_LEAF_HEIGHT_MODEL_CHOICES, translate),
                },
                modelKey: `goodDamages.${index}.leafHeight`,
                toPayload: (leafHeight) => ({ leafHeight }),
            },
        });
    }
    return fields;
}
